import { FluidTable } from '../fluid-table';

/**
 * Default cache state for first render
 */
export const tableStateCache = {
  _disabledFields: {},
};

/**
 * Updates the host tables's disabled field cache for each row, so that we
 * can track and apply modified disabled state between renders.
 * @param host - the host table
 * @param rowId - the rowId the disabled field is in
 * @param dataPath - the dataPath of the element to update
 * @param disabled - the current disabled state of the element
 */
export const updateEditableCellDisabledCache = (
  host: FluidTable,
  rowId: string,
  dataPath: string,
  disabled: boolean
) => {
  host._tableStateCache = {
    ...host._tableStateCache,
    _disabledFields: {
      ...host._tableStateCache._disabledFields,
      [rowId]: {
        ...host._tableStateCache._disabledFields[rowId],
        [dataPath]: disabled,
      },
    },
  };
};

/**
 * Returns true if the editable cell is disabled in cache.
 * @param host - the host table
 * @param rowId - the rowId of the field we're checking
 * @param dataPath - the dataPath of the field we're checking
 */
export const cellDisabledByCache = (
  host: FluidTable,
  rowId: string,
  dataPath: string
): boolean => {
  return !!host._tableStateCache._disabledFields[rowId]?.[dataPath];
};
